import PaymentsGrid from './components/PaymentsGrid/PaymentsGrid.vue';

export default {
    components: { PaymentsGrid },
    data() {
        return {
            value1: ''
        }
    }
}